import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const CategoryDocumentInput = ({name, label, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "planner_documents_category_document_1",
    },
    {
      value: 2,
      label: "planner_documents_category_document_2",
    },
    {
      value: 3,
      label: "planner_documents_category_document_3",
    },
    {
      value: 4,
      label: "planner_documents_category_document_4",
    },
    {
      value: 5,
      label: "planner_documents_category_document_5",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default CategoryDocumentInput;
